// extracted by mini-css-extract-plugin
export default {"wrapper":"HeetsPearlCollection_wrapper__UDkhS"};